import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NewsletterUnsubscribeConfirmation, NewsletterUnsubscribeInitialState } from './newsletter-unsubscribe.actions';
import { NewsletterUnsubscribeState, NewsletterUnsubscribeStateModel } from './newsletter-unsubscribe.state';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';

@Injectable({ providedIn: 'root' })
export class NewsletterUnsubscribeFacade implements LoadDataFacade, SetInitialStateFacade {
  newsletterData$: Observable<NewsletterUnsubscribeStateModel> = this.store.select(NewsletterUnsubscribeState.getState);
  loaded$: Observable<boolean> = this.store.select(NewsletterUnsubscribeState.getLoaded);

  constructor(private store: Store) {}

  loadAll(token: string): void {
    this.store.dispatch(new NewsletterUnsubscribeConfirmation(token));
  }

  setInitialState(): void {
    this.store.dispatch(new NewsletterUnsubscribeInitialState());
  }
}
